import Sidebar from './Sidebar';

const ModelTab2 = () => {

let syn1 = 'https://static.igem.wiki/teams/5066/drylab/syn1.png';
let syn2 = 'https://static.igem.wiki/teams/5066/drylab/syn2.png'
let syn3 = 'https://static.igem.wiki/teams/5066/drylab/syn3.png'
let syn4 = 'https://static.igem.wiki/teams/5066/drylab/model-tab2-2.png'
let syn6 = 'https://static.igem.wiki/teams/5066/drylab/model-tab2-3.png'
let syn7 = 'https://static.igem.wiki/teams/5066/drylab/model-tab2-4.png'
let syn8 = 'https://static.igem.wiki/teams/5066/drylab/model-tab2-5.png'
let syn9 = 'https://static.igem.wiki/teams/5066/drylab/larv3.png'

    let sections = [
        {id:'s1', name:'Introduction'},
        {id:'s2', name:'Evaluation of the Toxin Structures'},
        {id:'s3', name:'Predicting the Optimal Synergism ratio'},
        {id:'s4', name:'Reference'},
    ]

	return (
        <div className='flex'>

            <Sidebar sections={sections} />

            {/* Main Content */}
            <div className='flex-col w-full lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-white shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>

                <div className='pb-12'>
                    <section id='s1'>
                        <h2 className='text-3xl font-bold text-[#C94C67]'>
                            Introduction
                        </h2>
                        <div className='mt-4'>
                            <p className='mt-2 text-gray-700'>
                                Mixtures of functionally diverse toxins might be more effective than single toxins (​​Tabashnik,1992). To   estimate the synergism effect of the toxin mixtures, we first model the protein structures. Then, with the larvae mortality rate data for individual toxins from Wetlab, we incorporate Tabashnik’s formula to predict the concentration threshold for 50% larvae mortality rate, under the synergistic effects when combining multiple toxins together. With these estimations, we were able to inform the Wetlab team beforehand how toxin mixtures might perform in the larvicidal assays.
                            </p>
                        </div>
                    </section>
                </div>

                <div className='pb-12'>
                    <section id='s2' >
                        <h2 className='text-3xl font-bold text-[#C94C67]'>
                        Evaluation of the Toxin Structures
                        </h2>
                        <p className='mt-5 text-gray-700'>
First, we built the homology models for Cyt2ba and BmK IT1 using online servers for protein structure prediction: SWISS-Model. Because Xpp81Aa1, a mosquitocidal toxin sourced from the thioredoxin domain from Bt strain HSY204, is relatively novel, its genetic sequence isn’t available in NIH’s Nucleotide Genbank. Hence we opted for the next best alternative, Cry37, which according to the NIH, “Bacillus Thuringiensis strain HSY204 has a Cry37 toxin like gene” (NIH, 2021).
                        </p>
                        <br></br>
                        <p className='mt-5 text-gray-700'>
                            The results of the calculations are visualized in the table below. 
                        </p>
                        <table className="min-w-full table-auto border-collapse border border-gray-300">
                                <thead>
                                    <tr>
                                        <th className="border border-gray-300 px-4 py-2"></th>
                                        <th className="border border-gray-300 px-4 py-2">Seq identity</th>
                                        <th className="border border-gray-300 px-4 py-2">GMQE</th>
                                        <th className="border border-gray-300 px-4 py-2">QMEANDisCo Global, Local Quality Estimate, QMEAN Z-score </th>
                                        <th className="border border-gray-300 px-4 py-2">Protein structure</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">Cyt2Ba</td>
                                        <td className="border border-gray-300 px-4 py-2">70.70%</td>
                                        <td className="border border-gray-300 px-4 py-2">0.98</td>
                                        <td className="border border-gray-300 px-4 py-2">0.90 ± 0.07<br></br><img src={syn6} alt='imp__img'></img></td>
                                        <td className="border border-gray-300 px-4 py-2"><img src={syn1} alt='imp__img'></img></td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">Cry37 (similar to Xpp81Aa1)</td>
                                        <td className="border border-gray-300 px-4 py-2">99.21%</td>
                                        <td className="border border-gray-300 px-4 py-2">0.95</td>
                                        <td className="border border-gray-300 px-4 py-2">0.91 ± 0.07<br></br><img src={syn7} alt='imp__img'></img></td>
                                        <td className="border border-gray-300 px-4 py-2"><img src={syn2} alt='imp__img'></img></td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">BmK IT1</td>
                                        <td className="border border-gray-300 px-4 py-2">100.00%</td>
                                        <td className="border border-gray-300 px-4 py-2">0.88</td>
                                        <td className="border border-gray-300 px-4 py-2">0.62 ± 0.09<br></br><img src={syn8} alt='imp__img'></img></td>
                                        <td className="border border-gray-300 px-4 py-2"><img src={syn3} alt='imp__img'></img></td>
                                    </tr>
                                </tbody>
                        </table>
                        <p className='mt-5 text-gray-700'>
QMEANDisCo is a composite scoring function that measures the absolute quality of a single model both global (average residue quality of entire structure) and local (per residue). QMEANDisCo in range [0,1] indicates reliability. 
                        </p>
                        <p className='mt-5 text-gray-700'>
The Local Quality Estimate diagram is an illustration of all local QMEANDisCo scores for each residue. 
                        </p>
                        <p className='mt-5 text-gray-700'>
QMEAN Z-score is a scoring function of the degree of comparability of the prediction structure to an experimental structure of similar size. QMEAN Z-scores in range [0, -4.00] indicate good agreement.
                        </p>
                        <p className='mt-5 text-gray-700'>
The QMEANDisCo Local Quality Estimate and QMEAN Z-scores are shown in their respective rows. Template B5ABW0.1.A for Cyt2ba has 70.70% sequence identity; 0.98 GMQE score; 0.90 ± 0.07 QMEANDisCo score. Template 4rhz.1.B for Cry37 has 99.21% sequence identity; 0.95 GMQE score; 0.91 ± 0.07 QMEANDisCo score. Template O61668.1.A for BmK IT1 has 100.00% sequence identity; 0.88 GMQE score; 0.62 ± 0.09 QMEANDisCo score. 
                        </p>
                        <p className='mt-5 text-gray-700'>
Overall, the use of templates B5ABW0.1.A, 4rhz.1.B, and O61668.1.A for Cyt2ba, Cry37, BmK IT1, respectively, are appropriate predictions for protein structure. 
                        </p>
                    </section>
                </div>
                <div className='pb-12'>
                    <section id='s3' >
                        <h2 className='text-3xl font-bold text-[#C94C67]'>
                            Predicting the Optimal Synergism ratio
                        </h2>
                        <p className='mt-5 text-gray-700'>
According to Tabashnik’s suggestions, instead of using the arithmetic mean, it turns out that using a weighted harmonic mean produces more accurate results for LC50 (LC50 is the concentration threshold for larvicidal toxins to reach 50% mortality rate in mosquito larvicidal assays). The weighted harmonic mean predicts the LC50 value utilizing the ratios of Cyt2Ba, BmK IT1, and Xpp81Aa1 in Tabashnik’s reciprocal formula. However, we believe that an even better prediction can be achieved by incorporating the LC50 values from Wetlab data.
                        </p>
                        <p className='mt-5 text-gray-700'>
We hypothesized that when a toxin has lower LC50 values, that means the toxin is more effective against larvae, therefore should take up a bigger portion in the mix.
                        </p>
                        <p className='mt-5 text-gray-700'>
From our wetlab’s larvicidal assay, we successfully obtained LC50 values for the three toxins: Cyt2Ba, BmK IT1, and Xpp81Aa1. The LC50 values were 5,289,986 CFU/mL, 1,290,000,000 CFU/mL, and 3,162,276 CFU/mL, respectively. The data are than implemented into the calculation for the prediction of synergistic effect 
                        </p>
                        <br></br>
                        <img src={syn9} alt='imp_img'></img>
                        <table className="min-w-full table-auto border-collapse border border-gray-300">
                                <thead>
                                    <tr>
                                        <th className="border border-gray-300 px-4 py-2">Type of Toxins</th>
                                        <th className="border border-gray-300 px-4 py-2">LC50 (CFU/ml)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">Cyt2Ba</td>
                                        <td className="border border-gray-300 px-4 py-2">5,289,986</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">BmK IT1</td>
                                        <td className="border border-gray-300 px-4 py-2">1,290,000,000</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">Xpp81Aa1</td>
                                        <td className="border border-gray-300 px-4 py-2">3,162,276</td>
                                    </tr>
                                </tbody>
                        </table>
                        <img src={syn4} alt='imp__img' className='items-center w-[400px] h-auto'></img>
                        <p className='mt-5 text-gray-700'>
To predict the LC50 of the mixture with the LC50 values and ratios of the mixture,Tabashnik’s formula for <i>LC50</i> of toxicant mixtures is <i>LC50<sub>mix</sub></i> = {" "}
        <i>[ (r<sub>A</sub> / LC<sub>A</sub>) + (r<sub>B</sub> / LC<sub>B</sub>) + (r<sub>C</sub> / LC<sub>C</sub>) ]<sup>-1</sup></i>
        (Tabashnik, 1992). However, we wanted to take the effectiveness of each toxin into account when deciding the ratio of each toxin. Therefore, the ratio of the respective toxins are: 
                        </p>
                        <ul>
                            <li>
                            <i>r<sub>Cyt2Ba</sub> = LC50<sup>-1</sup><sub>Cyt2Ba</sub> / (LC50<sup>-1</sup><sub>Cyt2Ba</sub> + LC50<sup>-1</sup><sub>BmK IT1</sub> + LC50<sup>-1</sup><sub>Xpp81Aa1</sub>) = 37.356%</i>
                            </li>
                            <li>
                            <i>r<sub>BmK IT1</sub> = LC50<sup>-1</sup><sub>BmK IT1</sub> / (LC50<sup>-1</sup><sub>Cyt2Ba</sub> + LC50<sup>-1</sup><sub>BmK IT1</sub> + LC50<sup>-1</sup><sub>Xpp81Aa1</sub>) = 0.153%</i>
                            </li>
                            <li>
                            <i>r<sub>Xpp81Aa1</sub> = LC50<sup>-1</sup><sub>Xpp81Aa1</sub> / (LC50<sup>-1</sup><sub>Cyt2Ba</sub> + LC50<sup>-1</sup><sub>BmK IT1</sub> + LC50<sup>-1</sup><sub>Xpp81Aa1</sub>) = 62.491%</i>
                            </li>
                        </ul>
                        <p className='mt-5 text-gray-700'>
        We initially calculated the synergistic LC50 values between each pair of toxins, followed by the case when all three toxins combined. Through our calculations, we obtained LC50 values for the following toxin pairs and the triplet: Cyt2ba and BmK IT1; BmK IT1 and Xpp81Aa1; Cyt2ba and Xpp81Aa1; Cyt2ba and BmK IT1 and Xpp81Aa1. The respective LC50 values were 5,311,590 CFU/mL, 3,170,090 CFU/mL, and 4,226,131 CFU/mL, and 3,683,241 CFU/mL.
                        </p>
                        <table className="min-w-full table-auto border-collapse border border-gray-300">
                                <thead>
                                    <tr>
                                        <th className="border border-gray-300 px-4 py-2">Combination of Toxins </th>
                                        <th className="border border-gray-300 px-4 py-2">Predicted LC50 (CFU/ml)</th>
                                        <th className="border border-gray-300 px-4 py-2">Ratio</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">Cyt2Ba + BmK IT1</td>
                                        <td className="border border-gray-300 px-4 py-2">5311590</td>
                                        <td className="border border-gray-300 px-4 py-2">0.996 : 0.004</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">BmK IT1 + Xpp81Aa1</td>
                                        <td className="border border-gray-300 px-4 py-2">3170009</td>
                                        <td className="border border-gray-300 px-4 py-2">0.002 : 0.998</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">Cyt2Ba + Xpp81Aa1</td>
                                        <td className="border border-gray-300 px-4 py-2">4226131</td>
                                        <td className="border border-gray-300 px-4 py-2">0.374 : 0.626</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-300 px-4 py-2">Cyt2Ba + BmK IT1+ Xpp81Aa1</td>
                                        <td className="border border-gray-300 px-4 py-2">3683241</td>
                                        <td className="border border-gray-300 px-4 py-2">0.374 : 0.002 : 0.625</td>
                                    </tr>
                                </tbody>
                        </table>
                        <p className='mt-5 text-gray-700'>
These estimations allow the Wetlab team to better gauge the potential results of this merge of toxins. In the future, we wish to work with Wetlab on new larvicidal assays, to test whether our estimates are accurate, or compare toxicant mixtures with our optimized ratio and mixtures with uniformly distributed ratios. 
                        </p>
                    </section>
                </div>
                <div className='pb-12'>
                    <section id='s4'>
                        <h2 className='text-3xl font-bold text-[#C94C67]'>
                            Reference
                        </h2>
                        <div className='mt-4'>
                            <p className='mt-2 text-gray-700'>
Bruce E. Tabashnik, Evaluation of Synergism Among Bacillus thuringiensis Toxins,
Tabashnik, B. E. (1992). Evaluation of synergism among Bacillus thuringiensis toxins. Applied and Environmental Microbiology, 58(10), 3343–3346. 
https://www.ncbi.nlm.nih.gov/pmc/articles/PMC183101/
                            </p>
                            <p className='mt-2 text-gray-700'>
Guex N, Peitsch MC, Schwede T
Automated comparative protein structure modeling with SWISS-MODEL and Swiss-PdbViewer: A historical perspective.
Electrophoresis 30, S162-S173. (2009)
PubMed logo19517507
DOI logo10.1002/elps.200900140
                            </p>
                            <p className='mt-2 text-gray-700'>
Jiangyu Wu, Li Wei, Jiali He, Kang Fu, Xinxin Li, Luyu Jia, Ruiping Wang, Wenfei Zhang,
Characterization of a novel Bacillus thuringiensis toxin active against Aedes aegypti larvae,
Acta Tropica, Volume 223, 2021, 106088, ISSN 0001-706X, https://doi.org/10.1016/j.actatropica.2021.106088
                            </p>
                            <p className='mt-2 text-gray-700'>
Studer G, Rempfer C, Waterhouse AM, Gumienny R, Haas J, Schwede T
QMEANDisCo - distance constraints applied on model quality estimation.
Bioinformatics 36, 1765-1771. (2020)
PubMed logo31697312
DOI logo10.1093/bioinformatics/btz828
                            </p>
                            <p className='mt-2 text-gray-700'>
Varadi M, Anyango S, Deshpande M, Nair S, Natassia C, Yordanova G, Yuan D, Stroe O, Wood G, Laydon A, Žídek A, Green T, Tunyasuvunakool K, Petersen S, Jumper J, Clancy E, Green R, Vora A, Lutfi M, Figurnov M, Cowie A, Hobbs N, Kohli P, Kleywegt G, Birney E, Hassabis D, Velankar S
AlphaFold Protein Structure Database: massively expanding the structural coverage of protein-sequence space with high-accuracy models.
Nucleic Acids Res., 50, D439–D444. (2022)
PubMed logo34791371
DOI logo10.1093/nar/gkab1061
                            </p>
                            <p className='mt-2 text-gray-700'>
Waterhouse A, Bertoni M, Bienert S, Studer G, Tauriello G, Gumienny R, Heer FT, de Beer TAP, Rempfer C, Bordoli L, Lepore R, Schwede T
SWISS-MODEL: homology modelling of protein structures and complexes.
Nucleic Acids Res 46, W296-W303. (2018)
PubMed logo29788355
DOI logo10.1093/nar/gky427
                            </p>
                            <p className='mt-2 text-gray-700'>
Waterhouse AM, Studer G, Robin X, Bienert S, Tauriello G, Schwede T
The structure assessment web server: for proteins, complexes and more.
Nucleic Acids Res 52, W318-W323. (2024)
PubMed logo38634802
DOI logo10.1093/nar/gkae270
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
	);
};
export default ModelTab2;